export default "__VITE_ASSET__CnmDVLHt__"